import { isEmpty } from 'lodash'

import cardFlag from 'helpers/cardFlag'

import constants from 'constants/index'

const { STRING_SCHEMA_TYPE } = constants.validations

const cardNumber = {
  name: 'cardNumber',
  schemaType: STRING_SCHEMA_TYPE,
  method(message = 'Cartão inválido') {
    return this.test(
      'cardNumber',
      message,
      (value) => isEmpty(value) || !!cardFlag.identify(value),
    )
  },
}

export default cardNumber
